import React, { useCallback, useEffect, useState } from 'react'
import { Button, Form, Nav, Tab } from 'react-bootstrap'
import { toast } from 'react-toastify';
import { isValidName } from '../common/utilities/Validations';
import { DYNAMIC_TABLE, ADD_UPDATE, getApiPath, VIEW } from '../../api/ApiConst';
import apiCaller from "../../api/ApiCaller";
import textUtils from '../common/utilities/TextUtils';
import { useLocation, useParams } from 'react-router-dom';
import TableAttributes from './TableAttributes';
import TableIndexes from './TableIndexes';
import TableAPIListing from './tableAPIListing';

const SingleTableUpdateStructure = (props) => {
    const location = useLocation();
    const [tableDetailData, setTableDetailData] = useState(location.state);
    const { updateTableName: tableId } = useParams();
    const [createOrUpdate, setCreateOrUpdate] = useState(false);
    const [tableData, setTableData] = useState({
        id: "",
        name: "",
        description: "",
        pathValue: "",
        addDefaultAttribute: false,
        isMultiTenantTable: false,
    });

    useEffect(() => {
        fetchTableDetail((tableDetailData?.recordData?._id || tableId));
        setCreateOrUpdate(true);
    }, []);

    // Fetch Selected Table Detail
    const fetchTableDetail = async (tableId) => {
        let getTableDataUrl = getApiPath(DYNAMIC_TABLE,VIEW, tableId);
        apiCaller.callGetApi(getTableDataUrl, {}, (response) => {
            setTableData({
                id: response.id,
                name: response.name,
                description: response.description,
                pathValue: response.pathValue,
                addDefaultAttribute: response.addDefaultAttribute,
                isMultiTenantTable: response.isMultiTenantTable,
            });
            //setTableDataId(response.id);
        }, (error) => {
            console.error(error);
        })
    }

    // Handle Table Input Fields Value
    const handleTextChange = (e, type) => {
        if (type === "text" || type === "textarea") {
            if (e.target.id === "name") {
                if (!createOrUpdate) {
                    var flag = isValidName(e.target.value)
                    if (!flag) {
                        return;
                    }
                    setTableData(prev => ({ ...prev, [e.target.id]: e.target.value }));
                }
            } else {
                setTableData(prev => ({ ...prev, [e.target.id]: e.target.value }));
            }
        } else if (type === "checkbox") {
            setTableData(prev => ({ ...prev, [e.target.id]: e.target.checked }));
        }
    }

    // Update Table Data
    const handleUpdateTableData = async () => {
        if ((textUtils.isEmpty(tableData.name, "Name", true)) ||
            (textUtils.isEmpty(tableData.description, "Description", true))) {
            return false;
        }

        let url = getApiPath(DYNAMIC_TABLE, ADD_UPDATE);
        apiCaller.callPostApi(url, tableData, {}, (response) => {
            toast.success("Table Updated Successfully");
        }, (error) => {
            // toast.error(error.response.data.message);
        })
    }
    
    const getTableUpdateForm = () => {
        return (
            <>
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Name</Form.Label>
                        <input
                            type="text"
                            placeholder="Table Name"
                            className="form-control"
                            autoComplete='off'
                            name='name'
                            id='name'
                            value={tableData.name}
                            onChange={(e) => handleTextChange(e, e.target.type)}
                            disabled={true}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Path *</Form.Label>
                        <input
                            type="text"
                            placeholder="Path...."
                            className="form-control"
                            autoComplete='off'
                            name='pathValue'
                            id='pathValue'
                            value={tableData.pathValue}
                            onChange={(e) => handleTextChange(e, e.target.type)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Description *</Form.Label>
                        <textarea
                            className="form-control"
                            id="description"
                            name='description'
                            placeholder="Description"
                            rows="3"
                            value={tableData.description}
                            onChange={(e) => handleTextChange(e, e.target.type)}
                        >
                        </textarea>
                    </Form.Group>
                    <Form.Group className="mb-1" controlId="formBasicPassword">
                        <input
                            type="checkbox"
                            name="addDefaultAttribute"
                            id="addDefaultAttribute"
                            checked={tableData.addDefaultAttribute}
                            onChange={(e) => handleTextChange(e, e.target.type)}
                        />
                        <Form.Label className='ms-2'>Add Default Attribute </Form.Label>
                    </Form.Group>
                    <Form.Group className="mb-1" controlId="formBasicPassword">
                        <input
                            type="checkbox"
                            name="isMultiTenantTable"
                            id="isMultiTenantTable"
                            checked={tableData.isMultiTenantTable}
                            onChange={(e) => handleTextChange(e, e.target.type)}
                        />
                        <Form.Label className='ms-2'>Multi Tenant Table </Form.Label>
                    </Form.Group>
                    <Form.Group
                        className='text-end'>
                        <Button
                            type="button"
                            className='btn btn-primary'
                            onClick={handleUpdateTableData}
                        >
                            Update
                        </Button>
                    </Form.Group>
                </Form>
            </>
        )
    }

    return (
        <div className="row justify-content-end">
            <div className="col-12 px-0">
                <div className="row">
                    <div className="col-lg-3">
                        <div className='card bg-light rounded'>
                            <div className='card-body'>
                                <div className="text-center">
                                    <h5>Table {tableData.name} Detail</h5>
                                </div>
                                {getTableUpdateForm()}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {tableData.id !== "" &&
                            <Tab.Container defaultActiveKey="attributes">
                                <Nav variant="tabs" className="mb-3">
                                    <Nav.Item>
                                        <Nav.Link eventKey="attributes">
                                            <i className="fas fa-columns me-2"></i>
                                            Attributes
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="indexes">
                                            <i className="fas fa-database me-2"></i>
                                            Indexes
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey="attributes">
                                        <TableAttributes
                                            id={tableData.id}
                                            tableName={tableData.name}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="indexes">
                                        <TableIndexes
                                            tableId={tableData.id}
                                            tableName={tableData.name}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        }
                    </div>
                </div>
            </div>
            <TableAPIListing tableData={tableData} />
        </div>
    )
}

export default SingleTableUpdateStructure